export default {
  AUTH_KEY_REDUX: 'auth',
  TOKEN_KEY: 'NOOBDEV',
}
